import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useInviteStore } from '../store/use-invite-store';
import { useFormattedDateTime } from './use-formatted-date-time';

export function useEnrichedInvite() {
  const { invite } = useInviteStore();
  const { t: tCommon } = useTranslation('common');
  const { t: tSpecialist } = useTranslation('page.specialist');

  const { t, formattedDate, formattedTime } = useFormattedDateTime(
    invite.appointment
      ? `${invite.appointment?.appointmentDate}T${invite.appointment?.appointmentTime}`
      : null,
  );

  return useMemo(
    () => ({
      ...invite,
      practitioners: invite.practitioners.map((practitioner) => ({
        ...practitioner,
        practitionerRole: tCommon(`roles.${practitioner.practitionerRole}`),
        ...tSpecialist(`specialists.${practitioner.practitionerId}`, {
          returnObjects: true,
        }),
      })),
      requestingPractitioner: {
        ...invite.requestingPractitioner,
        practitionerRole: tCommon(`roles.${invite.requestingPractitioner.practitionerRole}`),
      },
      appointment: invite.appointment
        ? {
            ...invite.appointment,

            specialist: tSpecialist(
              `specialists.${invite.appointment?.practitioner?.practitionerId ?? 'unknown'}.name`,
            ),
            date: formattedDate,
            time: formattedTime,
            t,
          }
        : null,
    }),
    [formattedDate, formattedTime, invite, t, tCommon, tSpecialist],
  );
}
